"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var storybook_1 = require("@eyecons/storybook");
var types = {
    button: function (_a) {
        var onClick = _a.onClick, children = _a.children;
        return react_1.default.createElement(storybook_1.Buttons.Button, { onClick: onClick }, children);
    },
    link: function (_a) {
        var href = _a.href, children = _a.children;
        return react_1.default.createElement("a", { href: href }, children);
    }
};
var Button = function (_a) {
    var children = _a.children, href = _a.href, className = _a.className, onClick = _a.onClick;
    var Component = href ? types.link : types.button;
    return react_1.default.createElement("div", { className: "storybook-cards-button" + (className ? " " + className : '') },
        react_1.default.createElement(Component, { href: href, onClick: onClick }, children));
};
exports.Button = Button;
exports.Button.propTypes = {
    /**
     * The children of the Buttons
     */
    children: prop_types_1.default.any,
    /**
     * The href of the Button
     */
    href: prop_types_1.default.string,
    /**
     * The className of the Button
     */
    className: prop_types_1.default.string
};
